import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { useIsStudent, useHasRole } from '@reducers/user/hooks';
import { useReportsFeatureAccessQuery } from '@components/ReportGenerator/ReportQueries';
import ReportGenerator from './ReportGenerator';
import GeneratedReports from '../GeneratedReports/GeneratedReports';
import ReportPDFViewer from '../ReportPDFViewer/ReportPDFViewer';
import { AvailableReportsData } from './types';

interface ReportGeneratorRouterProps {
  availableReportsData?: AvailableReportsData;
}

const ReportGeneratorRouter: React.FC<ReportGeneratorRouterProps> = ({ availableReportsData }) => {
  const isStudent = useIsStudent();
  const hasRole = useHasRole();
  const isStudentSkillLevelReportEnabled = useReportsFeatureAccessQuery('student_skill_level_report');

  if (!hasRole || (isStudent && !isStudentSkillLevelReportEnabled)) {
    return null;
  }

  return (
    <Switch>
      <Route exact path="/admin/reports/generator">
        <ReportGenerator availableReportsData={availableReportsData} />
      </Route>
      <Route exact path="/admin/reports/generator/list">
        <GeneratedReports />
      </Route>
      <Route exact path="/admin/reports/generator/:reportId">
        <ReportPDFViewer />
      </Route>
    </Switch>
  );
};

export default ReportGeneratorRouter;
